

import { Observable } from 'rxjs';
import { Parameter } from '../common/parameter';
import { Binary } from '@angular/compiler';

export interface FavoriteMedicineParameter extends Parameter {
    searchTerm: number;
    orderBy: string;

}

export interface FavoriteMedicine {
    id?: any;
    name:string;
    medicineId:string;
    days:number;
    mor:string;
    aft:string;
    eve:string;
    night:string;
    qty:number;
    takenAt:string;
	instructions:string;
    tenantId: string;
    branchId: string;
    frequency?: string;
    advice?: string;
    dosage?: string;
    dosageunit?: string;
    duration?: number;
    durationUnit?: string;

    parameters?: FavoriteMedicineParameter[];
    links?: any;
    sortOrderId?:number;
    physicianId?:string;
    createdDate?:Date;
    updatedDate?:Date,
    createdBy?:number,
    updatedBy?:number,
    createdIP?:string,
    updatedIP? :string
}


export abstract class FavoriteMedicineData {
    //abstract fireRequest(data: Department, method: string): Observable<any>;
    abstract list(url: string): Observable<FavoriteMedicine[]>;
    abstract create(url: string, data: FavoriteMedicine): Observable<FavoriteMedicine[]>;
    abstract update(url: string, data: FavoriteMedicine): Observable<FavoriteMedicine>;
    abstract delete(url: string): Observable<any>;
}
